const initialState = {
  default: null,
  show: null,
  list: [],
  fetchingDefault: false,
  fetchedDefault: false,
  errorDefault: null,
  fetching: false,
  fetched: false,
  error: false,
  saved: false,
  saving: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "DATA_VIEW_DASHBOARD_DEFAULT_FETCH_PENDING":
      return {
        ...state,
        fetchingDefault: true,
        fetchedDefault: false,
      }
    case "DATA_VIEW_DASHBOARD_DEFAULT_FETCH_FULFILLED":
      return {
        ...state,
        default: action.payload.data,
        fetchingDefault: false,
        fetchedDefault: true,
      }
    default:
      return state
  }


}



// WEBPACK FOOTER //
// ./src/reducers/dataViewDashboardsReducer.js